import React, { PropTypes } from 'react';
import { Checkbox, RadioButtonGroup, RadioButton, Divider } from 'material-ui';
import FlatButton from '../../../tc-ui/flat-button-with-loader';
import StepperActions from '../../generic-components/stepper-actions';
import ReactSelect from 'react-select';
import R, {
  is,
  propEq,
  all,
  map,
  set,
  lensProp,
  pathOr,
} from 'ramda';

const CopyDataFromProductDialog = ({
  onRequestClose,
  contractId,
  ratePackageIndex,
  data,
  copyDataFromAnotherProduct,
  saving,
  onTextFieldChangeWithKeyPath,
  productsMap,
}) => {
  const onChange = onTextFieldChangeWithKeyPath;
  const fieldNameMap = {
    extras: 'Extras',
    offers: 'Offers',
    allocation: 'Allocation information',
    blackouts: 'Blackouts',
    pickup: 'Pick-up/Opening information',
    dropoff: 'Drop-off/Closing information',
    productPolicy: 'Product policy',
  };
  const onChangeRatesRadio = () => {
    if (data.addedProducts[data.productSelectedToBeCopied].productType !== data.thisProductType && data.withoutRates) {
      window.alert(`Sorry, you can not import rates from ${data.addedProducts[data.productSelectedToBeCopied].productType} product to ${data.thisProductType} product`);
    }
    else onChange({ keyPath: ['data', 'withoutRates'], value: !data.withoutRates });
  };
  const allChecked = all(propEq('checked', true), data.availableFields);
  const labelsAndValues = data.addedProducts.map((product, productIndex) => ({
    value: productIndex,
    label: `${productsMap[product.productId]} ${
      product.ratePackageName ? ` - ${product.ratePackageName}` : ''
    } (${product.percent}% completed)`,
  }));
  return (
    <div style={{ maxHeight: '550px' }}>
      <div
        style={{
          maxHeight: '500px',
          overflowY: 'scroll',
          margin: '16px 5%',
          width: '90%',
          minHeight: '300px',
        }}
      >
        <div style={{ marginBottom: '8px', marginLeft: '48px' }}>
          Please select a room type/product you want to copy data from:
        </div>
        {R.call(
          R.cond([
            [
              () => data.addedProducts.length > 5,
              R.always(
                <div style={{ width: '80%', marginLeft: '48px', marginBottom: '16px' }}>
                  <ReactSelect
                    style={{ fontSize: '14px' }}
                    name="allocation"
                    options={labelsAndValues}
                    value={data.productSelectedToBeCopied}
                    onChange={({ value }) =>
                      onChange({
                        keyPath: ['data', 'productSelectedToBeCopied'],
                        value: Number(value),
                      })
                    }
                    placeholder={`Search here...`}
                    clearable={false}
                    scrollMenuIntoView={false}
                  />
                </div>,
              ),
            ],
            [
              () => data.addedProducts.length,
              R.always(
                <RadioButtonGroup
                  name="selectProduct"
                  valueSelected={`${data.productSelectedToBeCopied}`}
                  onChange={(_, value) =>
                    onChange({
                      keyPath: ['data', 'productSelectedToBeCopied'],
                      value: Number(value),
                    })
                  }
                >
                  {labelsAndValues.map(({ label, value }, productIndex) => (
                    <RadioButton
                      key={productIndex}
                      value={`${productIndex}`}
                      style={{ marginTop: '12px' }}
                      label={
                        <div>
                          {label}
                          <Divider style={{ marginTop: '12px' }} />
                        </div>
                      }
                    />
                  ))}
                </RadioButtonGroup>,
              ),
            ],
            [
              R.T,
              R.always(
                <div style={{ margin: '70px', fontSize: '20px' }}>
                  There's no product information in this contract to copy from.
                </div>,
              ),
            ],
          ]),
        )}
        {data.productSelectedToBeCopied > -1 ? (
          <div style={{ marginLeft: '48px', width: '80%', marginTop: '24px' }}>
            <div style={{ marginBottom: '8px' }}>
              Please select the data you would like to copy from the product
            </div>
            <div style={{ color: '#ff4081', marginBottom: '24px' }}>{data.error || ''}</div>
            <Checkbox
              label="All"
              checked={allChecked}
              onCheck={() =>
                onChange({
                  keyPath: ['data', 'availableFields'],
                  value: map(set(lensProp('checked'), !allChecked), data.availableFields),
                })
              }
            />
            <Checkbox
              label="Seasons"
              checked={pathOr(false, ['availableFields', 0, 'checked'], data)}
              style={{ marginLeft: '24px', display: 'inline-block' }}
              onCheck={() =>
                onChange({
                  keyPath: ['data', 'availableFields', 0, 'checked'],
                  value: !pathOr(false, ['availableFields', 0, 'checked'], data),
                })
              }
            />
            {pathOr(false, ['availableFields', 0, 'checked'], data) ? (
              <div style={{ marginLeft: '36px' }}>
                <RadioButton
                  checked={data.withoutRates}
                  onCheck={onChangeRatesRadio}
                  style={{ width: '45%', display: 'inline-block' }}
                  label="Without rates"
                />
                <RadioButton
                  checked={!data.withoutRates}
                  onCheck={onChangeRatesRadio}
                  style={{ width: '45%', display: 'inline-block' }}
                  label="With rates"
                />
              </div>
            ) : (
              <div />
            )}
            {data.availableFields
              .filter(obj => obj.field !== 'seasonRates')
              .map((fieldObject, fieldIndex) => (
                <Checkbox
                  label={fieldNameMap[fieldObject.field]}
                  checked={fieldObject.checked}
                  style={{ marginLeft: '24px' }}
                  key={fieldIndex}
                  onCheck={() => {
                    const realIndex = data.availableFields.findIndex(
                      o => o.field === fieldObject.field,
                    );
                    onChange({
                      keyPath: ['data', 'availableFields', realIndex, 'checked'],
                      value: !fieldObject.checked,
                    });
                  }}
                />
              ))}
          </div>
        ) : (
          ''
        )}
      </div>
      <StepperActions
        rightButtons={
          <div>
            <FlatButton
              label="Cancel"
              labelStyle={{ fontWeight: '600', marginRight: '15px' }}
              primary
              onTouchTap={onRequestClose}
            />
            <FlatButton
              label="Save"
              loader={saving}
              disabled={
                !is(Number, data.productSelectedToBeCopied) || data.productSelectedToBeCopied < 0
              }
              labelStyle={{ fontWeight: '600' }}
              onTouchTap={() => {
                const dataFieldsToImport = R.call(
                  R.compose(
                    R.ifElse(R.contains('seasonRates'), R.append('seasons'), R.identity),
                    R.map(R.prop('field')),
                    R.filter(R.propEq('checked', true)),
                  ),
                  data.availableFields,
                );
                copyDataFromAnotherProduct({
                  contractId,
                  ratePackageNeedDataIndex: ratePackageIndex,
                  ratePackageHasDataIndex:
                    data.addedProducts[data.productSelectedToBeCopied].ratePackageIndex,
                  withoutRates: data.withoutRates,
                  dataFieldsToImport,
                });
              }}
              secondary
            />
          </div>
        }
      />
    </div>
  );
};

CopyDataFromProductDialog.propTypes = {
  onRequestClose: PropTypes.func,
  contractId: PropTypes.string,
  data: PropTypes.object,
};

export default CopyDataFromProductDialog;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/copy-data-from-another-product.jsx